type FilterArrowProps = React.SVGProps<SVGSVGElement> & {
  column?: string;
  sortField?: string | undefined;
  sortOrder?: string | undefined;
};

export const FilterArrows: React.FC<FilterArrowProps> = ({
  column,
  sortField,
  sortOrder,
  ...props
}) => {
  let upColor = "currentColor";
  let downColor = "currentColor";

  let upActive = false;
  let downActive = false;

  if (sortField === column) {
    if (sortOrder === "ASC") {
      upActive = true;
    } else {
      downActive = true;
    }
  }

  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 17.5L16 22.5L21 17.5H11Z"
        fill={downActive ? "var(--inzeloop-ds-color-icon-ink)" : downColor}
        data-sort-active={downActive}
      />
      <path
        d="M21 14.5L16 9.5L11 14.5H21Z"
        fill={upActive ? "var(--inzeloop-ds-color-icon-ink)" : upColor}
        data-sort-active={upActive}
      />
    </svg>
  );
};
